module.exports = __webpack_public_path__ + "static/hclavenderlotion-2eee6a3a4cd7e77139956a45583673fd.jpg";